import { Drawer } from "@mui/material";
import "./ConfigurationDrawer.scss";
import { UserWidget } from "@/common/constants/online.homepagegateway.api";
import { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import { updateWidgetInit } from "@/common/actions/widgetActions";
import { ConfigurationDrawerProps } from "./ConfigurationDrawerProps";
import ConfigurationDrawerHeader from "./ConfigurationDrawerHeader";
import ConfigurationDrawerTitle from "./ConfigurationDrawerTitle";
import ConfigurationDrawerButtons from "./ConfigurationDrawerButtons";

export const UpdateTitleOnlyDrawer = ({
  handleToggle,
  open,
  widget,
}: ConfigurationDrawerProps) => {
  const [widgetTitle, setWidgetTitle] = useState<string>('');
  const dispatch = useDispatch();

  useEffect(() => {
    getWidgetTitle();
  }, [widget]);

  const updateWidget = () => {

    const updatedWidget = {
      id: widget.id,
      name: widget.name,
      widgetId: widget.widgetId,
      title: widgetTitle,
      layouts: widget.layouts,
      currentLayout: widget.currentLayout,
    } as UserWidget;

    dispatch(updateWidgetInit(updatedWidget));
    handleToggle();
  }

  const getWidgetTitle = () => {
    setWidgetTitle(widget.title);
  }

  const cancelChanges = () => {
    getWidgetTitle();
    handleToggle();
  };

  const responsiveDrawer = (
    <div className="configuration-wrapper">
      <ConfigurationDrawerHeader handleToggle={handleToggle} />
      <ConfigurationDrawerTitle widgetTitle={widgetTitle} setWidgetTitle={setWidgetTitle} />
      <ConfigurationDrawerButtons updateWidget={updateWidget} cancelChanges={cancelChanges} />
    </div>
  );

  return (
    <Drawer 
      open={open}
      onClose={cancelChanges}
      anchor="right"
      PaperProps={{
        square: false
      }}
    >
      {responsiveDrawer}
    </Drawer>
  );
}

export default UpdateTitleOnlyDrawer;